var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 14,
    fill: "#E8FAF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3337 16C24.3337 20.6023 20.6027 24.3333 16.0003 24.3333C11.398 24.3333 7.66699 20.6023 7.66699 16C7.66699 11.3976 11.398 7.66663 16.0003 7.66663C20.6027 7.66663 24.3337 11.3976 24.3337 16ZM19.3589 13.4747C19.603 13.7188 19.603 14.1145 19.3589 14.3586L15.1923 18.5252C14.9482 18.7693 14.5525 18.7693 14.3084 18.5252L12.6417 16.8586C12.3976 16.6145 12.3976 16.2188 12.6417 15.9747C12.8858 15.7306 13.2815 15.7306 13.5256 15.9747L14.7503 17.1994L16.6127 15.337L18.4751 13.4747C18.7191 13.2306 19.1149 13.2306 19.3589 13.4747Z",
    fill: "#10793C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccess);
export default __webpack_public_path__ + "static/media/modal-success.37e6bb2a574007ebd704fc7b084fdc19.svg";
export { ForwardRef as ReactComponent };